import { useContext } from "react"
import { FeatureContext } from "../context"

export default () => {
  const context = useContext(FeatureContext)
  if (!context) {
    throw new Error('FeatureContext cannot be used outside FeatureContext.Provider')
  }
  return context
}